module.exports = __webpack_public_path__ + "media/application/images/customers/craft-supply-house-e4a052cd228d4dfbbc025757ead6a4d5.jpg";